/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SubmissionUpdateSubmissionParam model module.
 * @module model/SubmissionUpdateSubmissionParam
 * @version 1.0
 */
class SubmissionUpdateSubmissionParam {
    /**
     * Constructs a new <code>SubmissionUpdateSubmissionParam</code>.
     * @alias module:model/SubmissionUpdateSubmissionParam
     */
    constructor() { 
        
        SubmissionUpdateSubmissionParam.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SubmissionUpdateSubmissionParam</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SubmissionUpdateSubmissionParam} obj Optional instance to populate.
     * @return {module:model/SubmissionUpdateSubmissionParam} The populated <code>SubmissionUpdateSubmissionParam</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SubmissionUpdateSubmissionParam();

            if (data.hasOwnProperty('applicant')) {
                obj['applicant'] = ApiClient.convertToType(data['applicant'], 'String');
            }
            if (data.hasOwnProperty('competitionId')) {
                obj['competitionId'] = ApiClient.convertToType(data['competitionId'], 'Number');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('filePath')) {
                obj['filePath'] = ApiClient.convertToType(data['filePath'], 'String');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'String');
            }
            if (data.hasOwnProperty('userId')) {
                obj['userId'] = ApiClient.convertToType(data['userId'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {String} applicant
 */
SubmissionUpdateSubmissionParam.prototype['applicant'] = undefined;

/**
 * @member {Number} competitionId
 */
SubmissionUpdateSubmissionParam.prototype['competitionId'] = undefined;

/**
 * @member {String} description
 */
SubmissionUpdateSubmissionParam.prototype['description'] = undefined;

/**
 * @member {String} filePath
 */
SubmissionUpdateSubmissionParam.prototype['filePath'] = undefined;

/**
 * @member {String} status
 */
SubmissionUpdateSubmissionParam.prototype['status'] = undefined;

/**
 * @member {Number} userId
 */
SubmissionUpdateSubmissionParam.prototype['userId'] = undefined;






export default SubmissionUpdateSubmissionParam;

